module.exports = __webpack_public_path__ + "static/media/temp_acc.b6931344.svg";